module.exports = __webpack_public_path__ + "static/media/bizbook-welcome.ca40e706.png";